// extracted by mini-css-extract-plugin
export default {"dropdown":"Dropdown__dropdown___xB1fb","animated":"Dropdown__animated___gHDoL","open":"Dropdown__open___Gdtjw"};